export const TABLE_CLASSES = {
  TH: 'f7 f6-l ph2 pv2 ph3-l pv3-l b--silver near-black basier-med normal',
  TD: 'f7 f6-l ph2 pv1 ph3-l pv2-l bt',
};

export const METADATA_OPTION_MAX_LENGTH = 255;

export const METADATA_TITLE_MAX_LENGTH = 255;
